import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import StJosephHeroSection from "./components/HeroSection";
import StJosephStickyNav from "./components/StickyNav";
import StJosephProcessingTimeSection from "./components/ProcessingTimeSection";
import StJosephServicesSection from "./components/ServicesSection";
import StJosephLocalAreaSection from "./components/LocalAreaSection";
import StJosephTravelTimingSection from "./components/TravelTimingSection";
import StJosephDestinationsSection from "./components/DestinationsSection";
import StJosephTestimonialsSection from "./components/TestimonialsSection";
import StJosephAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import StJosephComparisonSection from "./components/ComparisonSection";
import StJosephMistakesSection from "./components/MistakesSection";
import StJosephHowItWorksSection from "./components/HowItWorksSection";
import StJosephFAQSection, { faqs } from "./components/FAQSection";
import StJosephHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import StJosephFinalCTA from "./components/FinalCTA";

export default function StJosephPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="St. Joseph"
        state="Missouri"
        stateAbbr="MO"
        route="/cities/st-joseph-mo"
        title="Emergency Passport St. Joseph, MO — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in St. Joseph, MO — as fast as 24 hours. No appointment race in Kansas City. A+ BBB rated, registered State Dept. courier serving Northwest Missouri agriculture professionals, MWSU students, and Buchanan County families on the I-29 corridor."
        geoPlacename="St. Joseph, Missouri"
        geoPosition="39.7675;-94.8467"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Missouri"
        statePageRoute="/states/missouri"
      />
      <StJosephHeroSection />
      <StJosephStickyNav />
      <StJosephProcessingTimeSection />
      <StJosephServicesSection />
      <StJosephLocalAreaSection />
      <StJosephTravelTimingSection />
      <StJosephDestinationsSection />
      <StJosephTestimonialsSection />
      <StJosephAcceptanceFacilitiesSection />
      <StJosephComparisonSection />
      <StJosephMistakesSection />
      <StJosephHowItWorksSection />
      <StJosephFAQSection />
      <StJosephHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/st-joseph-mo" state="MO" />
      <StJosephFinalCTA />
    </div>
  );
}